var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVisa(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 22,
    viewBox: "0 0 32 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "visa-color_large"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "card_bg",
    width: 32,
    height: 21.3333,
    rx: 4,
    fill: "#2A2A6C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "visa-logo",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.2361 11.78C20.2402 10.7635 19.4019 10.3245 18.7513 9.98376C18.3394 9.76807 18.0028 9.59178 18.0028 9.33335C18.0028 9.11335 18.2161 8.88001 18.6695 8.82001C19.209 8.76663 19.7529 8.86112 20.2428 9.09335L20.5228 7.76001C20.0452 7.58092 19.5395 7.48836 19.0295 7.48668C17.4561 7.48668 16.3628 8.32668 16.3628 9.52668C16.3628 10.4133 17.1561 10.9067 17.7561 11.2C18.3561 11.4933 18.5895 11.7 18.5828 11.9667C18.5828 12.38 18.0895 12.5667 17.6295 12.5733C17.062 12.5807 16.5021 12.443 16.0028 12.1733L15.7161 13.5067C16.2811 13.7272 16.883 13.8381 17.4895 13.8333C19.1628 13.8333 20.2628 13.0067 20.2695 11.7267L20.2361 11.78ZM15.9099 7.59335L14.5766 13.76H12.9766L14.3099 7.59335H15.9099ZM22.6172 11.5933L23.4572 9.28001L23.9439 11.5933H22.6172ZM25.8768 13.78H24.3968L24.2034 12.86H22.1968L21.8701 13.78H20.1901L22.5834 8.06668C22.6938 7.79485 22.9567 7.61603 23.2501 7.61335H24.5834L25.8768 13.78ZM11.076 13.74L13.6627 7.57336H11.9294L10.2694 11.7667L9.60271 8.20002C9.5437 7.83759 9.22991 7.57186 8.86271 7.57336H6.14937L6.10938 7.75336C6.6536 7.85983 7.18222 8.03455 7.68271 8.27336C7.89588 8.37358 8.04034 8.57886 8.06271 8.81336L9.33604 13.74H11.076Z",
    fill: "white"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.2c16233a22b69f730719927a3eaf711b.svg";
export { ForwardRef as ReactComponent };